import { render, staticRenderFns } from "./caijima.vue?vue&type=template&id=fa93262e&scoped=true&"
import script from "./caijima.vue?vue&type=script&lang=js&"
export * from "./caijima.vue?vue&type=script&lang=js&"
import style0 from "./caijima.vue?vue&type=style&index=0&id=fa93262e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa93262e",
  null
  
)

export default component.exports